import 'slick-carousel';

const $sliders = $('section[data-init="slider-with-popup"]');

function preloadSlide(images) {
  images.each(function loadImage() {
    const img = $(this);

    if(img.data('src') && img.data('src') !== img.attr('src')) {
      img.attr('src', img.data('src'));
    }
  });
}

function initSlider() {
  const $context = $(this);
  const $slider = $('.slider-content', $context);
  const $counter = $('.slider-counter', $context);
  const $link = $('.slider-link a', $context);
  const events = 'init reInit afterChange';

  $slider.on(events, (event, slick, currentSlide) => {
    const i = currentSlide ? currentSlide : 0;
    const $active = $('.slick-active', $context);
    const $popupID =  $('.slider-item', $active).data('popup-id');
    const $popupTitle =  $('.slider-item', $active).data('popup-title');

    $counter.text(`${i + 1}/${slick.slideCount}`);

    if($popupID && $popupTitle && $($popupID).length) {
      $link
        .attr('href', $popupID)
        .text($popupTitle)
        .show();
    }else{
      $link.hide();
    }

    preloadSlide($(`div[data-slick-index="${i - 1}"]`).find('img'));
    preloadSlide($(`div[data-slick-index="${i + 1}"]`).find('img'));
  });

  $slider.slick({
    prevArrow: $('.nav-prev', $context),
    nextArrow: $('.nav-next', $context)
  });
  preloadSlide($('[data-slick-index="-1"]', $slider).find('img'));
  preloadSlide($('[data-slick-index="1"]', $slider).find('img'));
}

$sliders.each(initSlider);
